import fdsdCoureImage from "../../components/ProgramCatalog/assets/fundamentals-of-digitla-system-design.webp";

import { ECourseStatus, ICourse } from "../utils/utils";
import fdsd_26_flyer from "../../components/CoursePage/assets/fdsd_26.jpg";

export const fundamentalsOfDigitalSystemDesign: ICourse = {
  header: {
    courseImage: fdsdCoureImage,
    programCategory: "Short Course",
    difficultyLevel: "Intermediate",
    courseTitle: "Fundamentals of Digital System Design '24",
    specialization: "Build Your Own CPU",
    courseDescription:
      "Explore the essential principles of Digital System Design with Skill Surf’s comprehensive course. This program melds foundational theories with hands-on applications, equipping you to design and optimize digital systems effectively. Delve into circuit design, logic, and system architecture to build robust digital solutions that are crucial for today’s technology-driven landscapes.",
    registerButton: "Registration Closed!",
    registerLink: "",
    secondaryName: "",
  },
  headerSecondSection: {
    starCount: 4.5,
    reviewCount: 40,
    registrationDeadline: "",
    parameterOne: "Estimated Time",
    parameterTwo: "8 Weeks",
    parameterThree: "",
    collaborationLogos: [],
  },
  courseOutline: [
    {
      session: "",
      sessionContent: [
        {
          heading: "1. Introduction to Digital Design and SystemVerilog",
          description: "",
          subContent: [],
        },
        {
          heading: "2. Combinational logic circuits",
          description: "",
          subContent: [],
        },
        {
          heading: "3. Sequential logic circuits",
          description: "",
          subContent: [],
        },
        {
          heading: "4. Using the ASIC/FPGA tools to synthesize the design",
          description: "",
          subContent: [],
        },
        {
          heading: "5. Finite state machines",
          description: "",
          subContent: [],
        },

        {
          heading: "6. Clock integrationn",
          description: "",
          subContent: [],
        },

        {
          heading: "7. Optimizations and hierarchical design",
          description: "",
          subContent: [],
        },
      ],
    },
  ],
  faqs: [],
  experts: [],
  isExperts: false,
  studentReviews: [
    "On the 1st day, when I saw the registration details, I went through the course curriculum and I joined the course with an expectation. The team fulfilled my expectations 100%.",
    "The course is very interesting and provides a good knowledge in the intended learning area. I would like to see more courses like this in future.",
    "This was a great course. Although the instructors couldn't touch all the aspects, guiding the students on what to follow and refer to is a great thing. Grateful for the organizers and instructors sharing their knowledge. Hope to join the next courses as well.",
    "The personal ML/embedded projects that the instructors shared as case studies were really inspiring. Sharing the ups and downs and what to expect along this path is a real motivator!",
    "Flow of the content was really great. It will really help to beginners who are entering to ML & Edge computing.",
  ],
  facts: [
    {
      fact: "A review by Gartner found that as of 2018, just 10% of all data was processed at the edge. However, Gartner expects that by 2025",
      factBold: "75% of all porcessing with happen at the edge",
      author: "-digi.com-",
    },
    {
      fact: "The global market for Embedded AI is expected to grow at a 5.4% CAGR from 2021 to 2026, reaching about ",
      factBold: "USD 38.87 billion",
      author: "-dac.digital-",
    },
  ],
  classSchedule: [
    "21st March 2026: 7 PM - 9 PM (Concluded)",
    "29th March 2026: 7 PM - 9 PM",
    "4th April 2026: 7 PM - 9 PM",
    "5th April 2026: 7 PM - 9 PM",
    "18th April 2026: 7 PM - 9 PM",
    "19th April 2026: 7 PM - 9 PM",
    "25th April 2026: 7 PM - 9 PM",
    "26th April 2026: 7 PM - 9 PM",
  ],

  prerequisite:
    "Basic knowledge of programming in any language. Microcontroller programming knowledge will be a plus but not mandatory.",

  isCourseFlyer: true,
  flyer: {
    description:
      "Learn more about Fundamentals of Digital System short course from the course announcement flyer",
    button: "View Course Flyer",
    image: fdsd_26_flyer,
  },
  courseStatus: ECourseStatus.NEW,
  showTimer: false,
  learnMore: {
    description: "Read More About Fundamentals of Digital System",
    button: "Read More",
    articleLink:
      "https://medium.com/@SkillSurfEdu/the-global-shortage-of-chip-design-talent-and-the-importance-of-practical-training-238d053f0f56",
  },

  firstSessionFreeDetails: {
    instruction: {
      isInstructive: true,
      instructiveText:
        "The first session, which was free of charge to everyone, was held on 22 March 2026. The recording of the session is made available below.",
      instructiveTextSecond:
        "Only paid participants can attend from day 2 onwards. So, please complete the payment by ",
      date: "",
      dateSecond: "April 18th 2026.",
      buttonText: "View Course Outline",
      buttonTextInfo: "View Slides",
      viewIntruction: "View Instructions for Next Steps",
      instructionVideoTopic:
        "Recording of the first sessions held on 22 March 2026:",
      instructionVideoUrl: "fG-RWJYQEK8",
      videoTwoTopic: "",
      videoTwoUrl: "",
      viewIntructionLink: "https://learnova.skillsurf.lk/course-preview/21403",
      buttonLink: "", //course outline
      buttonLinkInfo:
        "https://drive.google.com/file/d/1J_HUfNkKTzMnSudSmCwQAizWEpgwwNyX/view?usp=drive_link", //slides url
      moreInformation:
        "For any questions, please email skillsurfedu@gmail.com.",
      slideButtonText: "Download Slides:",
      paymentInstructionButtonText: "here",
      paymentInstructionButtonLink:
        "https://youtu.be/pdLNamvKvlw?si=RHguP0GIEz_7Fic6",
      paymentInstructionText:
        "Payment and other related instructions can be found",
      /*    weeklySchedule: [
        "Introductory Session - held live on 22nd March 2026 ",
        "The class schedule will be released at the Introductory Session.",
      ], */
    },
  },

  meetSection: {
    meetDetails: false,
    introPara:
      "The introductory session, which is free of charge to everyone, will be held on 15th September (Sunday) 2024 at 10.30 am IST. This first session will give an overview of the course, the content covered, and the expected outcomes. Please use the Zoom link to join the session:",
    zoomLink:
      "https://learn.zoom.us/j/94267767096?pwd=UG53MnpaYjdyZGpQNnozemVNencwQT09",
    meetId: "942 6776 7096",
    passCode: "205fD32*",
    zoomLinkText: "Click here to join ",
    introSecondPara:
      "The introductory session and an email following the session will provide further instructions on how to make the payments and enroll in the course. See you on 15th!",
  },

  showSchedule: true,
};
